import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfillmentGroupData,
  INVENTORY_PROJECTION_LOADING,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { isOpenIsh } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { inventoryProjectionLoadingLabel } from "@redotech/redo-fulfillment-operations-common/inventory-projection-status-labels";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { InventoryProjectionBadge } from "../../common/inventory-projection-badge";

const catalogEntry =
  fgColumnEntries[FulfillmentGroupColumnKey.INVENTORY_PROJECTION];

export const InventoryProjectionColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    // Its group status may not be closed yet.
    if (!row.inventoryProjection || !isOpenIsh(row.status)) {
      return null;
    }
    return (
      <Flex pl="lg">
        {row.inventoryProjection === INVENTORY_PROJECTION_LOADING ? (
          <RedoBadge
            color="gray"
            size="xs"
            text={inventoryProjectionLoadingLabel}
          />
        ) : (
          <InventoryProjectionBadge
            inbound={row.inventoryProjection.inbound}
            status={row.inventoryProjection.status}
          />
        )}
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
